import {createAsyncThunk, createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {
    addFeatureLabelApi, deleteFeatureLabelApi,
    getFeatureLabelApi,
    updateFeatureLabelApi
} from "../../../services/manage-product/setting/featureLabelService";


export const getAllFeatureLabels = createAsyncThunk('featureLabel/getFeatureLabel', async (filters, {dispatch}) => {
    const response = await getFeatureLabelApi(filters);
    return response.response;
});

const buildFeatureLabelFormData = (data) => {
    const formData = new FormData();
    formData.append('title', data.title);
    if (data.icon && data.icon.length > 0) {
        formData.append('icon', data.icon[0]);
    }
    return formData;
};

export const addFeatureLabel = createAsyncThunk('featureLabel/addFeatureLabel', async (featureLabel, {
    dispatch,
    getState
}) => {
    try {
        const response = await addFeatureLabelApi(buildFeatureLabelFormData(featureLabel));
        const data = await response.response;
        dispatch(getAllFeatureLabels());
        toast.success("Add item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const updateFeatureLabel = createAsyncThunk('featureLabel/updateFeatureLabel', async (featureLabel, {
    dispatch,
    getState
}) => {
    try {
        const response = await updateFeatureLabelApi(buildFeatureLabelFormData(featureLabel), featureLabel.id);
        const data = await response.response;
        dispatch(getAllFeatureLabels());
        toast.success("Update item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const deleteFeatureLabel = createAsyncThunk('featureLabel/deleteFeatureLabel', async (id, {
    dispatch,
    getState
}) => {
    try {
        const response = await deleteFeatureLabelApi(id);
        const data = await response.response;
        dispatch(getAllFeatureLabels());
        toast.success("Delete item successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

const featureLabelAdapter = createEntityAdapter({});

export const {selectAll: selectFeatureLabel, selectById: selectFeatureLabelById} = featureLabelAdapter.getSelectors(
    state => state.product.featureLabel
);

const featureLabelSlice = createSlice({
    name: 'featureLabel',
    initialState: featureLabelAdapter.getInitialState({
        searchText: '',
        addDialog: {
            component: 'featureLabel',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
    }),
    reducers: {
        selectFeatureLabelSearchText: {
            reducer: (state, action) => {
                state.searchText = action.payload;
            },
            prepare: event => ({payload: event.target.value || ''})
        },
        openNewDialog: (state, action) => {
            state.addDialog = {
                component: 'featureLabel',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        openEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload
            };
        },
        closeEditDialog: (state, action) => {
            state.addDialog = {
                type: 'edit',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
    },
    extraReducers: {
        [getAllFeatureLabels.fulfilled]: featureLabelAdapter.setAll
    }
});

export const {
    selectFeatureLabelSearchText, openNewDialog,
    closeNewDialog,
    openEditDialog,
    closeEditDialog
} = featureLabelSlice.actions;

export default featureLabelSlice.reducer;
